<template>
  <span
    class="profit-change"
    :class="{
      'profit-change--negative': profitChange < 0,
    }"
  >
    {{ (profitChange > 0 ? '+' : '') + profitChange }}%
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { formatNumberWithDecimals } from "@kano/helpers/numberFormatter";

const props = defineProps<{
  startAmount: Number,
  endAmount: Number,
}>();

const profitChange = computed(() => {
  if (!props.endAmount) {
    return 0;
  }

  const profitChange = ((props.endAmount - props.startAmount) / props.startAmount) * 100;

  return formatNumberWithDecimals(profitChange, 4);
});
</script>

<style scoped lang="scss">
@use '@kanoAssets/styles/breakpoints.scss';

.profit-change {
  color: var(--color-green);
  font-size: 14px;
  line-height: 24px;

  &--negative {
    color: var(--color-red);
  }

  @include breakpoints.desktop {
    font-size: 18px;
    line-height: 26px;
  }
}
</style>